import { FormControl, InputLabel, Select, MenuItem, Box, Grid2, TextField, SelectChangeEvent } from '@mui/material';
import React, { ChangeEvent, ReactElement } from 'react';
import { SiteType } from '../../../../api/ClientApi';
import { SiteTypeSR } from '../../../../common/Types';
import { RootState } from '../../../../redux/reducers';
import { updateSiteName, updateSiteLocationInfo, updateSiteSiteType } from '../../../../redux/actions/siteActions';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import GoogleMaps from '../../../../common/components/googlemaps/GoogleMaps';
import { LatLngLiteral } from '../../../../common/components/googlemaps/Common';
import { LocationInfo } from '../../../../common/Extensions';

type SiteFormStepProps = {
    chooseType: boolean;
};

export default function SiteFormStep(props: SiteFormStepProps): ReactElement {
    const { chooseType } = props;

    const site = useAppSelector((state: RootState) => state.site.site);
    const googleMapsApiKey = useAppSelector((state) => state.commonInfo.googleMapApiKey);

    const dispatch = useAppDispatch();

    const handleInputElementChange = (event: ChangeEvent<HTMLInputElement>) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        switch (name) {
            case 'name':
                dispatch(updateSiteName(value));
                break;
            default:
                console.log('%cERROR', 'color: red');
        }
    };

    const handleLocationChange = (address: string, coordinates: LatLngLiteral): void => {
        const locationInfo: LocationInfo = { address: address, coordinates: coordinates };

        dispatch(updateSiteLocationInfo(locationInfo));
    };

    const handleSelectSiteType = (event: SelectChangeEvent<SiteType>) => {
        const value = event.target.value;
        if (value === SiteType[SiteType.ConstructionSite]) {
            dispatch(updateSiteSiteType(SiteType.ConstructionSite));
        } else if (value === SiteType[SiteType.Depot]) {
            dispatch(updateSiteSiteType(SiteType.Depot));
        } else if (value === SiteType[SiteType.Warehouse]) {
            dispatch(updateSiteSiteType(SiteType.Warehouse));
        }
    };

    return (
        <Box>
            <Box>
                <Grid2 container spacing={2} style={{ maxWidth: '700px', margin: 'auto' }}>
                    <Grid2 size={{ xs: 12, sm: chooseType ? 6 : 12 }}>
                        <TextField
                            error={!!site?.name && site?.name !== '' ? false : true}
                            required
                            fullWidth
                            name="name"
                            label="Naziv"
                            value={!!site?.name ? site?.name : ''}
                            variant="outlined"
                            onChange={handleInputElementChange}
                        />
                    </Grid2>
                    {chooseType && (
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                            <FormControl fullWidth error={!!site?.siteType ? false : true} required>
                                <InputLabel id="demo-simple-select-label">Tip</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={site?.siteType ?? ''}
                                    label="Tip"
                                    onChange={handleSelectSiteType}
                                >
                                    {Object.values(SiteType).map((st) => {
                                        return (
                                            <MenuItem key={st} value={st as SiteType}>
                                                {SiteTypeSR[st as SiteType]}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </Grid2>
                    )}

                    {!!googleMapsApiKey && googleMapsApiKey !== '' && (
                        <Grid2 size={{ xs: 12 }}>
                            <GoogleMaps
                                handleAddingAddress={handleLocationChange}
                                label="Adresa"
                                currLocation={site?.locationInfo}
                                apiKey={googleMapsApiKey}
                            />
                        </Grid2>
                    )}
                </Grid2>
            </Box>
        </Box>
    );
}
